import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import classname from 'classnames'
import { useTranslation } from 'react-i18next'

import { showNetworkTab } from '../../../config'
import useStyles from './styles'


const Tabs = ({ activeTab }) => {
  const { t } = useTranslation(['translation'])

  const classes = useStyles();
  const getClassForALink = name =>
    classname(classes.linkWrapper, { [classes.active]: activeTab === name })

  return (
    <div className={classes.tabsPanel}>
      <NavLink className={getClassForALink('placements')} to="/placements">{t('PLACEMENT.TITLE_TAB')}</NavLink>
      <NavLink className={getClassForALink('portal')} to="/portal">{t('PORTAL.TITLE_TAB')}</NavLink>
      <NavLink className={getClassForALink('campaigns')} to="/campaigns">{t('CAMPAIGN.TITLE_TAB')}</NavLink>
      {showNetworkTab && <NavLink className={getClassForALink('network')} to="/network">{t('NETWORK.TITLE_TAB')}</NavLink>}
      <NavLink className={getClassForALink('analytics')} to="/analytics">{t('ANALYTICS.TITLE_TAB')}</NavLink>
      <NavLink className={getClassForALink('questionnaire')} to="/questionnaire">{t('QUESTIONNAIRE.TITLE_TAB')}</NavLink>
      <NavLink className={getClassForALink('download')} to="/download">{t('DOWNLOAD.TITLE_TAB')}</NavLink>
      <NavLink className={getClassForALink('legalText')} to="/legal-text">{t('LEGAL_TEXT.TITLE_TAB')}</NavLink>
    </div>
  )
}

Tabs.defaultProps = {
  activeTab: '',
};

Tabs.propTypes = {
  activeTab: PropTypes.string,
};


export default Tabs;
